import { render, staticRenderFns } from "./AllocateToOtherStateView.vue?vue&type=template&id=7e720e70"
import script from "./AllocateToOtherStateView.vue?vue&type=script&lang=js"
export * from "./AllocateToOtherStateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports